import { useAccountsSectionController } from "./accounts/useAccountsSectionController";
import { useUsersSectionController } from "./users/useUsersSectionController";

function UsersSectionProvider(props) {
  const contract = useUsersSectionController(props);
  return props.children(contract);
}

function AccountsSectionProvider(props) {
  const contract = useAccountsSectionController(props);
  return props.children(contract);
}

export const managementSectionRegistry = {
  users: {
    id: "users",
    order: 1,
    Provider: UsersSectionProvider,
  },
  accounts: {
    id: "accounts",
    order: 2,
    Provider: AccountsSectionProvider,
  },
};

export function getSectionProvider(sectionId) {
  return managementSectionRegistry[sectionId]?.Provider || null;
}
